import axios, { AxiosResponse, AxiosError } from 'axios'

export const ENDPOINT = {
  SLAB: 'https://6q1vlowaa0.execute-api.ap-northeast-2.amazonaws.com/slabPlanning',
  BEAM: 'https://6q1vlowaa0.execute-api.ap-northeast-2.amazonaws.com/beamPlanning',
  COLUMN: 'https://6q1vlowaa0.execute-api.ap-northeast-2.amazonaws.com/columnPlanning',
  FOUNDATION: 'https://6q1vlowaa0.execute-api.ap-northeast-2.amazonaws.com/foundationPlanning',
  BASEMENTWALL: 'https://6q1vlowaa0.execute-api.ap-northeast-2.amazonaws.com/bewallPlanning',
  WINDTUNNELSTUDY: 'https://6q1vlowaa0.execute-api.ap-northeast-2.amazonaws.com/windTunnelStudying',
} as const

type ValueOf<T> = T[keyof T]
type Endpoint = ValueOf<typeof ENDPOINT>

function handleAxiosError (error: unknown, redirectionPage: string): void {
  let errorMessage = `Unexpected error: ${(error as Error).message}`
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError
    if (axiosError.response) {
      errorMessage = `Request failed with status code ${axiosError.response.status}: ${axiosError.response.data}`
    } else {
      errorMessage = `Axios error: ${axiosError.message}`
    }
  }

  alert(errorMessage)
  window.location.href = `/${redirectionPage}`
}

export const $POST = async <Response>(
  endpoint: Endpoint,
  payload?: object,
  redirectionPage?: string): Promise<Response> => {
  try {
    const res: AxiosResponse<Response> = await axios.post<Response>(
      endpoint,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-bs-api-key': 'bbdb6b50-oplh-7677-si1x-eaa717ef265b',
        },
      },
    )

    if (res.status === 200) {
      return res.data
    }
    throw new Error(`Unexpected response code: ${res.status}`)
  } catch (error) {
    handleAxiosError(error, redirectionPage ?? '')
    throw error
  }
}
